module.exports = __webpack_public_path__ + "img/lx_gzdp.4794e5fd.svg";